import React from "react";
import { MASTER_ADMIN_DATA_BAR } from "constants/ui-constants";
import Masterbar from "./Masterbar";

export default () => {
  return <Masterbar {...MASTER_ADMIN_DATA_BAR} />;
};
